var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-wrapper"},[_c('div',{staticClass:"timer-wrapper__timer",on:{"click":_vm.toggleActive}},[_c('ui-countdown',{attrs:{"time":_vm.getTime,"booking":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }